import request from "superagent";
import Auth from "../../routes/Auth";

const API = process.env.REACT_APP_API_URL;

const VALID_ROLES = ["CEO", "PD", "PM", "OP", "FI", "VI"];

const HEADER_ALIASES = {
  email: "email",
  emailaddress: "email",
  username: "email",
  role: "role",
  position: "role",
};

const normalizeHeader = (h) => (h || "")
  .toLowerCase()
  .replace(/\(.*?\)/g, "")
  .replace(/[^a-z0-9]+/g, "")
  .trim();

const readFileAsText = (file) => new Promise((resolve, reject) => {
  const reader = new FileReader();
  reader.onload = () => resolve(reader.result || "");
  reader.onerror = () => reject(new Error("Could not read the uploaded file."));
  reader.readAsText(file);
});

export const CHANGE_ROLES_TEMPLATE_CSV =
  "email,role\nexample@student.edu,CEO\n";

const extractErrors = (err) => {
  const body = err && err.response && err.response.body;
  if (body && body.errors && typeof body.errors === "object") {
    return Object.keys(body.errors).map(k => String(body.errors[k]));
  }
  if (body && body.detail) return [String(body.detail)];
  if (err && err.message) return [err.message];
  return ["Upload failed. Please try again."];
};

export const runChangeRolesUpload = async ({ file, gameId, onProgress }) => {
  const report = (stage, extra) => {
    if (onProgress) onProgress({ stage, ...(extra || {}) });
  };

  report("parsing");
  const text = await readFileAsText(file);
  const raw = String(text).replace(/^﻿/, "").split(/\r?\n/);
  const nonEmptyLines = raw.filter(l => l && l.trim().length > 0);

  if (nonEmptyLines.length === 0) {
    const err = new Error("CSV is empty.");
    err.kind = "validation";
    err.errors = ["The uploaded file is empty."];
    throw err;
  }
  if (nonEmptyLines.length < 2) {
    const err = new Error("CSV has no data rows.");
    err.kind = "validation";
    err.errors = ["The uploaded file has no data rows below the header."];
    throw err;
  }

  const headerLine = nonEmptyLines[0];
  const rawHeaders = headerLine.split(",").map(s => s.trim());
  const canonical = rawHeaders.map(h => HEADER_ALIASES[normalizeHeader(h)] || h);

  if (!canonical.includes("email")) {
    const err = new Error("Missing email column.");
    err.kind = "validation";
    err.errors = ['CSV must include an "email" column.'];
    throw err;
  }
  if (!canonical.includes("role")) {
    const err = new Error("Missing role column.");
    err.kind = "validation";
    err.errors = ['CSV must include a "role" column.'];
    throw err;
  }

  // Catch typos in the role column before BE does. Role values must
  // match the six-position whitelist. Report row number + bad value
  // so the instructor can locate it in the spreadsheet.
  const roleIdx = canonical.indexOf("role");
  const dataRows = nonEmptyLines.slice(1);
  const badRows = [];
  dataRows.forEach((line, i) => {
    const cells = line.split(",").map(c => c.trim());
    const roleVal = (cells[roleIdx] || "").toUpperCase();
    if (roleVal && !VALID_ROLES.includes(roleVal)) {
      badRows.push(`Row ${i + 2}: invalid role "${cells[roleIdx]}". Use one of ${VALID_ROLES.join(", ")}.`);
    }
  });
  if (badRows.length > 0) {
    const err = new Error("Invalid role values.");
    err.kind = "validation";
    err.errors = badRows;
    throw err;
  }

  const rewrittenHeader = canonical.join(",");
  const csv = [rewrittenHeader, ...dataRows].join("\n") + "\n";

  report("uploading");
  const token = Auth.getToken();
  const req = request
    .post(`${API}v2/games/bulk-assign-roles/`)
    .set("Accept", "application/json")
    .attach("file", new Blob([csv], { type: "text/csv" }), "change-roles.csv")
    .field("game_id", String(gameId));
  if (token) req.set("Authorization", `Token ${token}`);

  let res;
  try {
    res = await req;
  } catch (err) {
    const apiErr = new Error("Upload failed.");
    apiErr.kind = "api";
    apiErr.errors = extractErrors(err);
    throw apiErr;
  }

  const body = (res && res.body) || {};
  report("success", body);
  return body;
};



// WEBPACK FOOTER //
// ./src/instructor/utils/change-roles-upload.js